const ru = {
    // SpecialConditionsPart
    title: "Специальные условия для",
    weAlredyCheck: "Мы уже проверили вашу\u00a0компанию",
    based: "На основе отличной репутации и\u00a0многолетней работе в сфере грузоперевозок\u00a0вам доступен лимит {{money}}",
    fuelBased: "Вы профессионал и можете рассчитывать на\u00a0особые условия. Ваш лимит на топливо в\u00a0рассрочку — {{money}}",
    getAnnouncing: "Получить авансирование",
    getLine: "получить линию",
    learnDetails: "узнать подробности",
    useWhen: "Пользуйтесь,\nкогда\u00a0удобно",
    dontWait: "Не ждите оплату по\u00a0заказу",
    freeMoney: "Свободные деньги на\u00a0любые цели",
    forEvery: "За каждые 50 000 рублей вы заплатите всего\n500 рублей в неделю и 99 рублей в день",

    weAlredyCheckWithLink: "Мы всё проверили, осталось {{link}}",
    openPopupLink: "подписать документы",

    // TermsBlock
    limitForActivity: "За вашу активность уже доступен лимит {{money}}",
    documents: "Оформление по двум документам: ваша\u00A0заявка с клиентом + ТТН",
    request: "Получите 50% от заявки \n уже через 30 минут",
    paymentWhen: "Платите только, когда\nпользуетесь — от 1 дня до 1 года",
    withoutHiddenComission: "Без скрытых комиссий",

    fuelFirstItemTitle: "Вы можете заправляться в рассрочку без комиссии на {{money}}.",
    fuelSecondItemTitle: "Роснефть, Газпром нефть, Teboil. Скидки дают 8 000+ заправок.",
    fuelThirdItemTitle: "Без % и скрытых платежей.",

    // SentencePart
    sentence: "Предложение для",

    descriptionForCarrier: "Получайте предоплату по любым\nзаказам за 1% в неделю",
    descriptionForShipper: "Вам доступна кредитная линия {{money}}",
    descriptionForFuel: "У вас есть {{money}} на заправку\n\nПолучите топливо в рассрочку и со скидками, оплачивайте в течение 30\u00A0дней",
    descriptionForTopShipper: "Вам доступна кредитная линия {{money}} под 2,9% в месяц",

    buttonTitleForCarrier: "Получить предоплату",
    buttonTitleForShipper: "оформить онлайн",
    buttonTitleForFuel: "Получить деньги",

    buttonDescriptionForCarrier: "Вам доступно {{money}}",
    buttonDescriptionForShipper: "Получите деньги\nвсего {{minutes}}",
    buttonDescriptionForFuel: "Оформим {{minutes}}.\nПредложение ограничено",
    minutes: "за 30 минут",

    rubl: ["рубль", "рубля", "рублей"],

    // PromoPart
    titleForCarrier: "Оплата за любой заказ\nчерез 30 минут",
    titleForShipper: "Оформите кредитную линию сейчас — пользуйтесь деньгами, когда нужно",
    titleForFuel: "Заправляйтесь сейчас — платите потом.\nБез комиссии и переплат, ещё и\u00a0со\u00a0скидками",

    payment: "Получайте оплату сразу после погрузки\nили за уже выполненные заказы",
    limit: "Лимит до 5 000 000 рублей",
    individualLimit: "Индивидуальный лимит",
    onePersent: "Всего за 1% от стоимости заказа в неделю",
    payWhen: "Платите, когда с вами рассчитается клиент",
    youHaveMoney: "Деньги будут у вас через 30 минут после заявки",
    useMoney: "Используйте деньги так, как удобно и выгодно вам:",

    repayment: "Чтобы сделать оплату перевозчикам и заработать больше",
    repair: "На ремонт транспорта",
    salary: "На зарплату сотрудникам",

    workWithoutInterruption: "Работа пойдёт без простоев",
    freeMoneyAlwaysAtHand: "Свободные деньги — всегда под рукой",
    saveUp: "Получится сэкономить до 5%",

    fuelPromoDescription: "Получайте деньги на\u00a0топливо в\u00a0нужный момент — отдавайте в\u00a0течение месяца. Заправляйтесь в\u00a0крупнейших сетях АЗС по\u00a0всей России.",

    // Popup
    aplicationSend: "Заявка отправлена",
    close: "Закрыть",
    aplicationInProcess: "У вас уже есть заявка в\u00a0работе",
    fuelAplicationInProcess: "Вы уже оставляли заявку",
    weSendAMessageAdvancePayment: "Мы пришлем вам на почту договор авансирования, подпишите его и\u00a0направьте ответным письмом",
    fuelCheckAMessage: "Спасибо! Проверьте почту — в ближайшее время мы свяжемся с вами.",
    weSendAMessageCredit: "Мы пришлем вам на почту договор на кредитную линию, подпишите его и\u00a0направьте ответным письмом",
    getAdvance: "Получить авансирование",
    getCredit: "Получить кредитную линию",
    getFuel: "Получить топливо в рассрочку",
    avdanceAlreadySent: "Вам на почту уже выслан договор авансирования, подпишите его и\u00a0направьте ответным письмом",
    fuelAvdanceAlreadySent: "Если у вас есть вопросы, пожалуйста, свяжитесь с нами по\u00a0телефону +7\u00a0(926)\u00a0720\u00a097\u00a037.",
    creditAlreadySent: "Вам на почту уже выслан договор на\u00a0кредитную линию, подпишите его и\u00a0направьте ответным письмом",
    indicateTheAlmost: "Укажите сумму заявки, по которой получите предоплату",
    indicateHowMuch: "Укажите, какую сумму отправить вам на счёт?",
    indicateRefuel: "Укажите, на какую сумму вы хотите заправиться",
    yourEmail: "Ваш email",
    aplicationAmount: "Сумма заявки",
    submitAnAplication: "Отправить заявку",
    // FooterPart
    phoneInMoscow: "Наш телефон в Москве ",
    phoneNumber: "8 800 550-09-92",
    contentFooter: "ООО МКК «Бридж Капитал». Регистрационный номер записи в реестре микрофинансовых организаций 2203045009884 от 22.06.2022, ОГРН 1217700611534, ИНН 9723132301, КПП 772301001 Юридический адрес: 115193, г. Москва, вн.тер.г. муниципальный округ Южнопортовый, ул. Петра Романова, д. 7, стр. 1, мансарда 0, помещ./ком./офис VIII/1/21. Вводя номер телефона и заказывая звонок, Вы соглашаетесь на обработку Ваших персональных данных ООО МКК «Бридж Капитал» (Общество с ограниченной ответственностью Микрокредитная компания «Бридж Капитал»)",
    adressFooter: "Член СРО «Альянс» с 26.07.2022, регистрационный номер в реестре 0722030772030. 127055, г. Москва, ул. Сущёвская, д. 21, стр.1, этаж 5, офис 513, 514",
    dateOfEntry: "Дата внесения в реестр микрофинансовых организаций: 22.06.2022\nРегистрационный номер записи: 2203045009884",
    publicOffer: "Публичная оферта",
    certificateCB: "Cвидетельство ЦБ",
    extractFrom: "Выписка из реестра микрофинансовых организаций",
    loanRules: "Правила предоставления займов",
    // Global
    specifyTheAmount: "Укажите сумму заявки до ",
    enterTheEmail: "Укажите email в формате mailbox@example.com",
    emailsCannotBe: "На указанный email нельзя доставить письма",
    doNotUse: "Не используйте доменные имена нашей компании.",
    inABlackList: "Этот email в нашем черном списке. Укажите другой.",
} as const;

export default ru;
